<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!--for overlay :loading="get_ay_std_ft_loader" -->
        <!--api- 1  -->
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Employee Data </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-row dense justify="center" class="pb-0 mb-0">
                   
                    <v-radio-group v-model="field.radios" mandatory row class="ma-2 no-display">
                        <v-radio label="Working Employees" value="Working" color="#0f2027"></v-radio>
                        <v-radio label="Non-Working Employees" value="NotWorking" color="#0f2027"></v-radio>
                        <v-radio label="All" value="All" color="#0f2027"></v-radio>
                    </v-radio-group>
                    <v-btn class="button col-1 ma-4 mt-1" @click="getEmpData" :loading="fetch_btn_load">Fetch</v-btn>
                </v-row>
                <v-row justify="center" dense>
                        <v-switch color="#0F2027" v-model="all_toggle" label="Toggle All"></v-switch>
                </v-row>
                <v-row justify="space-around">
                    <v-switch color="#0F2027" v-model="field.employee_code" label="Employee Code"></v-switch>
                      <v-switch color="#0F2027" v-model="field.login_username" label="Login Username"></v-switch>
                    <v-switch color="#0F2027" v-model="field.oasis_id" label="Oasis Id"></v-switch>
                    <v-switch color="#0F2027" v-model="field.dateofjoining" label="Joining Date"></v-switch>
                     <v-switch color="#0F2027" v-model="field.dateofleaving" label="Date Of Leaving"></v-switch>
                    <v-switch color="#0F2027" v-model="field.iscurrentlyworking" label="Working Status"></v-switch>
                    <v-switch color="#0F2027" v-model="field.firstname" label="First Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.middlename" label="Middle Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.lastname" label="Last Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.fullname" label="Full Name"></v-switch>
                     <v-switch color="#0F2027" v-model="field.emp_national_code" label="National Code"></v-switch>
                    <v-switch color="#0F2027" v-model="field.date_of_birth" label="DoB"></v-switch>
                    <v-switch color="#0F2027" v-model="field.bloodgroup" label="Blood Group"></v-switch>
                    <v-switch color="#0F2027" v-model="field.aadhar_no" label="Aadhar No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mobile_no" label="Mobile No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.alternate_mobile_no"
                        label="Alternate Mobile No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.telephone_no" label="Telephone No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.emergency_contact_name"
                        label="Emergency Contact Name"></v-switch>
                    <!-- <v-switch color="#0F2027" v-model="field.emergency_contact_address" label="Emergency Contact Address"></v-switch> -->
                    <v-switch color="#0F2027" v-model="field.emergency_contact_number"
                        label="Emergency Contact Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birth_place" label="Birth Place"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birth_address" label="Birth Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.local_address" label="Local Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.permanent_address" label="Permanent Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.father_full_name" label="Father Full Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mother_first_name" label="Mother First Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.physicallyhandicapped_details"
                        label="Physically Handicapped Details"></v-switch>
                    <v-switch color="#0F2027" v-model="field.isphysicallyhandicapped"
                        label="Is physically Handicapped"></v-switch>
                    <v-switch color="#0F2027" v-model="field.date_of_birth_in_words"
                        label="Date Of Birth In Words"></v-switch>
                    <!-- <v-switch color="#0F2027" v-model="field.highest_qualification" label="Highest Qualification"></v-switch> -->
                    <v-switch color="#0F2027" v-model="field.official_email" label="Official Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.personal_email" label="Personal Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.institute_email" label="Institute Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.gender" label="Gender"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birthcountry" label="Birth Country"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mothertoungue" label="Mother Toungue"></v-switch>
                    <v-switch color="#0F2027" v-model="field.teaching_exp" label="Teaching Experience"></v-switch>
                    <v-switch color="#0F2027" v-model="field.training" label="Training"></v-switch>
                    <v-switch color="#0F2027" v-model="field.bank" label="Bank Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.bank_ifsc_code" label="IFSC"></v-switch>
                    <v-switch color="#0F2027" v-model="field.bank_account_no" label="Bank Account no"></v-switch>
                    <v-switch color="#0F2027" v-model="field.uan_no" label="UAN No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.pf_no" label="PF"></v-switch>
                    <v-switch color="#0F2027" v-model="field.last_pfno" label="Last PF No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.esic_no" label="ESIC No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.gratuity_number" label="Gratuity Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.spouse_name" label="Spouse Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.employee_type" label="Employee Type"></v-switch>
                    <v-switch color="#0F2027" v-model="field.employee_designation"
                        label="Employee Designation"></v-switch>
                    <v-switch color="#0F2027" v-model="field.employee_section" label="Employee section"></v-switch>

                    <v-switch color="#0F2027" v-model="field.highest_academic_qualification"
                        label="Highest Academic Qualification"></v-switch>
                    <v-switch color="#0F2027" v-model="field.highest_professional_qualification"
                        label="Highest Professional Qualification"></v-switch>
                    <v-switch color="#0F2027" v-model="field.total_teaching_experience"
                        label="Total Teaching Experience"></v-switch>
                    <v-switch color="#0F2027" v-model="field.teaching_experience_in_current_school"
                        label="Teaching Experience In Current School"></v-switch>
                    <v-switch color="#0F2027" v-model="field.sub_crt_stud_taughts"
                        label="Subject Certification (students taught)"></v-switch>
                    <v-switch color="#0F2027" v-model="field.main_sub_taughts" label="Main Subject Taught"></v-switch>
                    <v-switch color="#0F2027" v-model="field.additional_sub_taughts"
                        label="Additional Subject Taught"></v-switch>
                    <v-switch color="#0F2027" v-model="field.marital_status" label="Marital Status"></v-switch>
                    <v-switch color="#0F2027" v-model="field.deparment" label="department"></v-switch>
                    <v-switch color="#0F2027" v-model="field.pan_no" label="PAN NO"></v-switch>

                    <v-switch color="#0F2027" v-model="field.highest_specialization"
                        label="Highest Specialization"></v-switch>
                    <v-switch color="#0F2027" v-model="field.employeeshift" label="Employee Shift"></v-switch>
                    <v-switch color="#0F2027" v-model="field.hight_in_cm" label="Height in cm"></v-switch>
                    <v-switch color="#0F2027" v-model="field.weight_in_kg" label="Weight in KG"></v-switch>
                    <v-switch color="#0F2027" v-model="field.family_doctor_name" label="Family Doctor Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.family_doctor_contact"
                        label="Family Doctor Contact"></v-switch>
                    <v-switch color="#0F2027" v-model="field.family_history_of_any_disease"
                        label="Family History Of Any Disease"></v-switch>
                    <v-switch color="#0F2027" v-model="field.allergetic_to" label="Allergetic To"></v-switch>
                    <v-switch color="#0F2027" v-model="field.any_past_medical_surgery_medical_emergency"
                        label="Any Past Medical Surgery/Medical Emergency"></v-switch>
                    <v-switch color="#0F2027" v-model="field.is_medical_certificate_submitted"
                        label="Is Medical Certificate Submitted"></v-switch>
                    <v-switch color="#0F2027" v-model="field.photo" label="Employee Photo Status"></v-switch>
                    <v-switch color="#0F2027" v-model="field.sign" label="Employee Signature Status"></v-switch>
                     <v-switch color="#0F2027" v-model="field.employee_category" label="Employee Category"></v-switch>
                     


                </v-row>
            </v-card-text>
        </v-card>
        <br />
        <!-- api-1 ends -->

        <div v-if="field_list.length != 0">
            <v-row dense>
                <v-col cols="auto" class="pa-1">
                    <v-btn class="ma-2 no-display " rounded color="success" outlined
                        @click="fnExcelReport('my-table-id', 'EmployeeDataReport')" :loading="loader"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
                </v-col>
                <v-col cols="auto" class="pa-1">
                <v-btn class=" mt-2 no-display" tile outlined color="warning" @click="printPDF('my-table-id')"> 
                    <v-icon>mdi-printer</v-icon> Print Report<v-icon></v-icon> </v-btn>
                </v-col>

                 <v-col cols="auto" class="pa-1" v-if="field.photo">
                    <v-btn
                        class="mt-2 no-display"
                        tile
                        outlined
                        color="blue darken-1"
                        @click="downloadAllPhotos"
                        :disabled="isDownloadingPhotos"
                    >
                        <v-icon left>mdi-download</v-icon> Download Photos
                    </v-btn>
                </v-col>

                <v-col cols="auto" class="pa-1" v-if="field.sign">
                    <v-btn
                        class="mt-2 no-display"
                        tile
                        outlined
                        color="blue darken-1"
                        @click="downloadAllSignatures"
                        :disabled="isDownloadingSignatures"
                    >
                        <v-icon left>mdi-download</v-icon> Download Signatures
                    </v-btn>
                </v-col>
                <!-- <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          </v-col> -->
                <!-- <v-col cols="12" sm="6" md="6">

          <v-text-field
            id="myInput"
            @keyup="searchTable()"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-col> -->
            </v-row>

            <!-- <input type="text" v-model="search" /> -->
            <!-- search end -->
            <div id="my-table-id" class="mytable1">
                <!-- <div class="scroll"> -->
                <table id="admitted-student-report" dense class="elevation-1" fixed-header height="500px">
                    <thead>
                        <tr>
                            <th v-for="(hl, index) in header_list" :key="index">
                                {{ hl.text }}
                            </th>
                        </tr>
                    </thead>
                    <tbody style="overflow-y: scroll;">
                        <tr v-for="(fl, index) in field_list" :key="index">
                            <!-- for search added filteredItems -->
                            <!-- <tr v-for="(fl, index) in filteredItems" :key="index"> -->
                            <td v-for="(hl, index1) in header_list" :key="index1">
                                <div v-if="hl.value === 'photostatus'">
                                    <div v-if="fl.photo !== 'NA'">
                                        <img :src="fl.photo" width="50px" height="50px"><br>
                                    </div>
                                    <div v-else>
                                        NA
                                    </div>
                                </div>
                                <div v-else-if="hl.value === 'signaturestatus'">
                                    <div v-if="fl.signature !== 'NA'">
                                        <img :src="fl.signature" alt="Employee Signature"
                                            style="max-width: 50px; max-height: 50px;">
                                    </div>
                                    <div v-else>
                                        NA
                                    </div>
                                </div>
                                <div v-else>
                                    {{ fl[hl.value] }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <!-- <tr>
                            <th v-for="(hl, index) in header_list" :key="index">
                                {{ hl.text }}
                            </th>
                        </tr> -->
                    </tfoot>
                </table>
                <!-- </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        //1
        all_toggle: false,
        search: "",
        ay_std_data: null,
        fetch_btn_load: false,
        exs_loader: false,
        snackbar_msg: "",
        isDownloadingSignatures: false,
        isDownloadingPhotos: false,
        // extraBreadcrumbItems: [
          

        // ],
        breadcrumbClass: "breadcrumb-style1",
        color: "",
        snackbar: false,
        //fields
        field: {
            employee_code: false,
              login_username: false,
            marital_status: false,
            deparment: false,
            pan_no: false,
            hight_in_cm: false,
            weight_in_kg: false,
            family_doctor_name: false,
            family_doctor_contact: false,
            family_history_of_any_disease: false,
            allergetic_to: false,
            any_past_medical_surgery_medical_emergency: false,
            is_medical_certificate_submitted: false,
            highest_specialization: false,
            employeeshift: false,
            firstname: false,
            middlename: false,
            lastname: false,
            oasis_id: false,
            fullname: false,
            date_of_birth: false,
            bloodgroup: false,
            aadhar_no: false,
            mobile_no: false,
            alternate_mobile_no: false,
            telephone_no: false,
            emergency_contact_name: false,
            // emergency_contact_address: false,
            emergency_contact_number: false,
            birth_place: false,
            birth_address: false,
            local_address: false,
            permanent_address: false,
            father_full_name: false,
            mother_first_name: false,
            physicallyhandicapped_details: false,
            isphysicallyhandicapped: false,
            date_of_birth_in_words: false,
            // highest_qualification: false,
            official_email: false,
            personal_email: false,
            institute_email: false,
            gender: false,
            birthcountry: false,
            mothertoungue: false,
            dateofjoining: false,
            dateofleaving:false,
            teaching_exp: false,
            iscurrentlyworking: false,
            training: false,
            bank: false,
            bank_ifsc_code: false,
            bank_account_no: false,
            pf_no: false,
            esic_no: false,
            uan_no: false,
            last_pfno: false,
            gratuity_number: false,
            spouse_name: false,
            employee_type: false,
            employee_category: false,
            employee_designation: false,
            employee_section: false,
            dataTable: null,
            highest_academic_qualification: null,
            highest_professional_qualification: null,
            total_teaching_experience: null,
            teaching_experience_in_current_school: null,
            sub_crt_stud_taughts: false, main_sub_taughts: false, additional_sub_taughts: false, photo: false, sign: false,
            radios:'Working',
        },
        //2
        header_list: [],
        field_list: [],
        xls_header: [],
        org_details:[],
    }),
    watch: {
        all_toggle() {
            console.log(this.all_toggle);
            var keys = Object.keys(this.field);
            // console.log("keys:"+this.field[keys[0]])
            for (let i = 0; i < keys.length; i++) this.field[keys[i]] = this.all_toggle;
        },
    },
    computed: {
        // filteredItems() {
        //   return this.field_list.filter((item) => {
        //     return (
        //       item.fullname.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
        //       item.date_of_birth.toLowerCase().indexOf(this.search.toLowerCase()) >
        //         -1 ||
        //       item.employee_code.toLowerCase().indexOf(this.search.toLowerCase()) >
        //         -1 ||
        //       item.employee_type.toLowerCase().indexOf(this.search.toLowerCase()) >
        //         -1 ||
        //       item.bloodgroup.toLowerCase().indexOf(this.search.toLowerCase()) >
        //         -1 ||
        //       item.dateofjoining.toLowerCase().indexOf(this.search.toLowerCase()) >
        //         -1 ||
        //       item.aadhar_no.toLowerCase().indexOf(this.search.toLowerCase()) >
        //         -1 ||
        //       item.gender.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
        //       item.personal_email.toLowerCase().indexOf(this.search.toLowerCase()) >
        //         -1
        //     );
        //   });
        // },
    },
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },

       printPDF(id) {
            var printContents = document.getElementById(id).innerHTML;
            var win = window.open('', '', 'height=700,width=900');
            const org = this.org_details; 

            win.document.write(`
            <html>
            <head>
            <style>
            @page { 
                size: A4 landscape; 
                margin: 5mm;
            }

            body {
                font-family: Arial, sans-serif;
            }

            .header {
                display: flex;
                align-items: center;
                justify-content: center;
                // border-bottom: 2px solid black;
                margin-bottom: 10px;
                padding-bottom: 5px;
            }

            .logo {
                position: absolute;
                left: 10px;
            }

            .logo img {
                height: 60px;
                width: auto;
            }

            .school-details {
                text-align: center;
            }

            .school-name {
                font-size: 18px;
                font-weight: bold;
            }

            .trust-name {
                font-size: 12px;
            }

            .address {
                font-size: 10px;
            }

            table {
                width: auto;
                margin: 0 auto;
                border-collapse: collapse;
                font-size: 10px;   
                table-layout: auto;
            }

            th, td {
                border: 1px solid black;
                padding: 3px;
                text-align: center;
                word-break: break-word;   
            }

            thead {
                font-weight: bold;
                font-size: 11px;
            }

            div {
                overflow: visible !important;
            }
            </style>
            </head>
            <body>

            <div class="header">
                <div class="logo">
                    <img src="${org.school_logo}" />
                </div>
                <div class="school-details">
                    <div class="trust-name">${org.trust_name}</div>
                    <div class="school-name">${org.school_name}</div>
                    <div class="school-name mt-2">Employee Data Report</div>
                </div>
            </div>

            ${printContents}

            </body>
            </html>
            `);

            win.document.close();
            win.focus();

            setTimeout(() => {
                win.print();
                win.close();
            }, 500);
        },

        // searchTable() {
        //   var input, filter, found, table, tr, td, i, j;
        //   input = document.getElementById("myInput");
        //   filter = input.value.toUpperCase();
        //   table = document.
        // getElementById("my-table");
        //   tr = table.getElementsByTagName("tr");
        //   for (i = 0; i < tr.length; i++) {
        //     td = tr[i].getElementsByTagName("td");
        //     for (j = 0; j < td.length; j++) {
        //       if (td[j].innerHTML.toUpperCase().indexOf(filter) > -1) {
        //         found = true;
        //       }
        //     }
        //     if (found) {
        //       tr[i].style.display = "";
        //       found = false;
        //     } else {
        //       tr[i].style.display = "none";
        //     }
        //   }
        // },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getEmpData() {
            this.field_list = [];
            this.fetch_btn_load = true;
            axios
                .post("/admissionReport/getEmpData", this.field)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.field_list = res.data.field_list;
                        this.header_list = res.data.header_list;
                        this.xls_header = res.data.xls_header;
                        this.showSnackbar("success", "Fetched successfully, please find data in the below table"); // show snackbar on success
                    } else {
                        //error
                        this.showSnackbar("error", "Something went wrong"); // show snackbar on success
                    }
                })
                .catch((error) => {
                    this.showSnackbar("error", "Something went wrong"); // show snackbar on success
                })
                .finally(() => {
                    //close loader
                    this.fetch_btn_load = false;
                    this.dataTable = $("#admitted-student-report").DataTable({
                        colReorder: true,
                        dom: "Bfrtip",
                        buttons: ["csvHtml5", "excelHtml5", "print"],
                    });
                });
            // this.filteredItems();
        },
        get_ay_std() {
            //api-1
            axios
                .post("/feesMaster/get_ay_std_ft")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.ay_std_data = res.data.fees_structure_data;
                        this.field.current_academic_year = res.data.fees_structure_data.current_academic_year;
                        this.field.std = this.ay_std_data.standard_list[0];
                        this.org_details = res.data.org_details;
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                });
        },

        async downloadAllSignatures() {
            this.isDownloadingSignatures = true;
            this.showSnackbar("success", "Signatures are downloading, please wait...");
            
            const validEmployees = this.field_list.filter(item => item.signature !== "NA");

            const formData = {
                employees: validEmployees.map((item) => item.employee_code), 
            };

            try {
                axios
                    .post("/admissionReport/renderEmployeeSignatureZip", formData, {
                        responseType: "blob",
                    })
                    .then((res) => {
                        const blob = new Blob([res.data], { type: "application/zip" });
                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "Employee_Signatures.zip";
                        link.click();
                        
                        window.URL.revokeObjectURL(link.href);
                    })
                    .catch((error) => {
                        this.showSnackbar("error", "Failed to download signatures. Please try again.");
                        console.error(error);
                    })
                    .finally(() => {
                        this.isDownloadingSignatures = false;
                    });
            } catch (error) {
                this.showSnackbar("error", "Something went wrong...");
                this.isDownloadingSignatures = false;
            }
        },

          async downloadAllPhotos() {
            this.isDownloadingPhotos = true;
            this.showSnackbar("success", "Photos are downloading, please wait...");
            
            const validEmployees = this.field_list.filter(item => item.photo !== "NA");

            const formData = {
                employees: validEmployees.map((item) => item.employee_code), 
            };

            try {
                axios
                    .post("/admissionReport/renderEmployeePhotosZip", formData, {
                        responseType: "blob",
                    })
                    .then((res) => {
                        const blob = new Blob([res.data], { type: "application/zip" });
                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "Employee_Photos.zip";
                        link.click();
                        
                        window.URL.revokeObjectURL(link.href);
                    })
                    .catch((error) => {
                        this.showSnackbar("error", "Failed to download photos. Please try again.");
                        console.error(error);
                    })
                    .finally(() => {
                        this.isDownloadingPhotos = false;
                    });
            } catch (error) {
                this.showSnackbar("error", "Something went wrong...");
                this.isDownloadingPhotos = false;
            }
        },
    },
    mounted() {
        this.get_ay_std();
    },
};
</script>
<style>
.dt-button {
    font-size: 14px;
    font-weight: bold;
}

.dt-button.buttons-print::before {
    content: "\F42A";
    margin-right: 8px;
    margin-top: 8px;
    font-size: 18px;
    font-family: "Material Design Icons";
}

.dt-button.buttons-excel::before {
    content: "\F21B";
    margin-right: 8px;
    margin-top: 8px;
    font-size: 18px;
    font-family: "Material Design Icons";
}

.dt-button.buttons-csv::before {
    content: "\FEC2";
    margin-right: 8px;
    margin-top: 8px;
    font-size: 18px;
    font-family: "Material Design Icons";
}

button.dt-button:hover:not(.disabled),
div.dt-button:hover:not(.disabled),
a.dt-button:hover:not(.disabled) {
    border-color: #ff9800;
    color: #ff9800;
}

.dataTables_wrapper .dataTables_filter input[type="search"] {
    border-radius: 2px;
    border: 1px solid #cdcdcd;
    cursor: auto;
}

.mytable /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mytable1 {
    /* width: 90%; */
    overflow-x: scroll;
}

table,
th,
td {
    border: 1px solid rgb(201, 200, 200);
    border-collapse: collapse;
}
</style>